import { render, staticRenderFns } from "./2fa.vue?vue&type=template&id=6c905db6"
import script from "./2fa.vue?vue&type=script&lang=js"
export * from "./2fa.vue?vue&type=script&lang=js"
import style0 from "./2fa.vue?vue&type=style&index=0&id=6c905db6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports